<template>
    <v-flex xs12>
        <v-layout justify-space-between align-center wrap
                  :class="{'mx-3': $vuetify.breakpoint.xs}"
        >
            <v-flex sm7 xs12>
                <v-layout align-center>
                    <labelTopic :class="label_class(news_content.type)">{{ $t(news_content.label) }}</labelTopic>
                    <div v-if="news_content.date" :class="{'ml-2': $vuetify.breakpoint.xs, 'ml-4': $vuetify.breakpoint.smAndUp}">
                        <v-flex v-if="typeof news_content.date == 'number'" class="news_dates mobile small">
                            <div class=" font-weight-bold">{{ get_date(news_content.date) }}</div>
                            <div class="ml-2 grey-text">{{ get_time(news_content.date) }}</div>
                        </v-flex>
                        <v-flex v-else class="news_dates">
                            <div class=" font-weight-bold">{{ get_date(news_content.date[0]) }}</div>
                            <div class="ml-2 grey-text">{{ get_time(news_content.date[0]) }}</div>
                            <div class="mx-3"> - </div>
                            <div class=" font-weight-bold">{{ get_date(news_content.date[1]) }}</div>
                            <div class="ml-2 grey-text">{{ get_time(news_content.date[1]) }}</div>
                        </v-flex>
                    </div>
                </v-layout>
            </v-flex>
            <v-flex xl2 md3 sm5
                    xs12 text-md-right :class="{'mt-4': $vuetify.breakpoint.xs}"
            >
                <v-layout justify-start>
                    <iconLabel :icon_name="news_content.liked ? 'heart-filled' : 'heart'" class=" icon-label-red " size="20"
                               @click.native="like_news(news_content.id)"
                    >{{ news_content.likes }}</iconLabel>
                    <iconLabel :icon_name="news_content.favourite ? 'in-favorites' : 'favorites'" class="ml-4 icon-label-red" size="20"
                               @click.native="wrapper_to_favourites(news_content)"
                    >
                        {{ news_content.favourite ? $t('В избранном') : $t('В избранное') }}</iconLabel>
                </v-layout>
            </v-flex>
        </v-layout>

        <div class="display-1 my-5" :class="{'mx-3': $vuetify.breakpoint.xs}">{{ news_content.title }}</div>
        <v-layout class="wrap news__descr-wrapper justify-center" :class="{'mx-3': $vuetify.breakpoint.xs, 'justify-space-between': news_content.type !== 'news'}">
            <event-bar v-if="news_content.type !== 'news'"
                       :current_item_news ="news_content"
                       class="md4 xl3 xs12"
                       :class="{'pr-4': $vuetify.breakpoint.mdAndUp}"
            />

            <v-flex xl9 md8 xs12>

                <!-- <div class="news__descr-block">
                    <div class="news__descr-title news__descr-inside title-text">
                        {{ current_item_news.title }}
                    </div>
                    <div class="news__descr-descr">
                        {{ current_item_news.text }}
                    </div>
                </div>-->
                <component v-for="(block, i) in news_content.content" :key="i" :content='block.content'
                           class="mb-4" :is="block.type"
                />
            </v-flex>
        </v-layout>
        <div class="news__descr-block mt-5">
            <commentsBlock id="comments" />
        </div>
        <v-dialog :value="add_comment_modal" :width="$vuetify.breakpoint.mdAndUp ? 1100 : 'auto'" persistent>
            <newsAddCommentModal />
        </v-dialog>
    </v-flex>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex';
import buttonRed   from '@/components/ui/buttons/button_red';
import labelTopic from '@/components/ui/labels/label_topic';
import blockSlider from '@/components/blocks/content_blocks/block_slider.vue';
import blockVideo from '@/components/blocks/content_blocks/block_video.vue';
import blockDocuments from '@/components/blocks/content_blocks/block_documents.vue';
import blockText from '@/components/blocks/content_blocks/block_text.vue';
import iconLabel from '@/components/ui/icons/icon_with_label';
import EventBar from './event_bar.vue';
import newsAddCommentModal from './News_modals/news_add_comment';
import newsCommentModalEdit from './News_modals/news_comment_modal_edit';
import commentsBlock from './news_comments.vue';
import dayjs from 'dayjs';
import utc from 'dayjs-plugin-utc';

dayjs.extend(utc);

export default {
  components: {
    buttonRed,
    iconLabel,
    blockSlider,
    EventBar,
    blockVideo,
    labelTopic,
    blockDocuments,
    blockText,
    commentsBlock,
    newsAddCommentModal,
    newsCommentModalEdit,
  },
  computed: {
    ...mapGetters('news_main/detail', [
      'current_id', 'current_item_news', 'news_content', 'comments', 'comments', 'add_comment_modal', 'modal_comment_edit',
    ]),
    content() {
      return this.news_content.content[0].content;
    },
    date_from() {
      if (typeof this.current_item_news.date == 'object') {
        return new dayjs( this.current_item_news.date[0]).utc().format('DD.MM.YYYY');
      } else {
        return new dayjs( this.current_item_news.date).utc().format('DD.MM.YYYY');
      }
    },
    time_from() {
      if (typeof this.current_item_news.date == 'object') {
        return new dayjs( this.current_item_news.date[0]).utc().format('HH.mm');
      } else {
        return new dayjs( this.current_item_news.date).utc().format('HH.mm');
      }
    },
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.on_mount();
        this.CLOSE_CALENDAR();
      },
    },
  },
  async mounted() {
    await this.get_news_detail(this.$route.params.id);
    this.on_mount();
    setTimeout(()=>{
      this.jumpToComments();
    }, 100 );
  },
  destroyed() {
    this.SET_NEWS_DETAIL({});
    this.SET_CURRENT_ID(0);
    this.SET_COMMENTS([]);
  },
  methods: {
    wrapper_to_favourites(content) {
      this.toggle_favourites(content);
      this.TOGGLE_NEWS_DETAIL_FAVOURITE();
    },
    jumpToComments() {
      if (this.$route.hash) {
        let top = document.getElementById('comments').offsetTop;
        window.scrollTo(0, top);
      }
    },
    ...mapMutations('calendar', ['CLOSE_CALENDAR']),
    ...mapMutations('news_main', ['SET_CURRENT_ID']),
    ...mapActions('news_main', [
      'like_news',
    ]),
    ...mapActions('favourites', [
      'toggle_favourites',
    ]),
    ...mapMutations('news_main/detail', ['TOGGLE_NEWS_DETAIL_FAVOURITE', 'SET_NEWS_DETAIL', 'SET_COMMENTS']),
    ...mapActions('news_main/detail', ['get_news_detail']),
    on_mount() {
      this.SET_CURRENT_ID(this.$route.params.id);
    },
    label_class(type) {
      if (type == 'news') {
        return 'section-label--green';
      }
      if (type == 'events') {
        return 'section-label--grey';
      }
      if (type == 'actions') {
        return 'section-label--red';
      }
      if (type == 'marketing') {
        return 'section-label--blue';
      }
    },
    get_date(date) {
      return new dayjs(parseInt(date)).format('DD.MM.YYYY');
    },
    get_time(date) {
      return new dayjs(parseInt(date)).format('HH.mm');
    },
  },
};
</script>
